import { getInitials } from '@/shared/lib/helpers/get-initials.helper';

import { PowerOfAttorneyDelegate, PowerOfAttorneyUserResponse } from '../types/power-of-attorney-api.interface';

export const transformPowerOfAttorneyUser = ({
	id,
	username,
	email,
	name,
	surname,
	role,
}: PowerOfAttorneyUserResponse): PowerOfAttorneyDelegate => ({
	id,
	name: [name, surname].filter(Boolean).join(' ') || username,
	email,
	role,
	initials: getInitials(name || username, surname),
});
